export const IMAGE_TYPES = ['Picture', 'Url']
export const VIDEO_TYPES = ['video', 'youtube', 'vimeo']

const ONLINE_ONLY_TYPES = [...VIDEO_TYPES, 'sketchfab']

export interface SlideData {
  type: string;
  url?: string;
  src?: string;
  alt?: string;
  title?: string;
  legend?: string;
  legendSize?: string;
  style?: { videoRatios?: string };
  withButton?: boolean;
  buttonStyle?: { alternate?: boolean; flat?: boolean };
  buttonUrl?: string;
  buttonText?: string;
  [key: string]: any;
}

export const isSlideRenderable = (slide: SlideData, online: boolean): boolean => {
  if (!slide) return false
  if (IMAGE_TYPES.includes(slide.type) || slide.type === '360') return true
  return ONLINE_ONLY_TYPES.includes(slide.type) && online
}